export enum QueryParams {
    SEND_INVITE_KEY = 'sendInvite',
    CANCEL_INVITE_KEY = 'cancelInvite',
    ACCEPT_INVITE_KEY = 'acceptInvite',
    // ... other query params
}
